export const isObject = <T extends object>(arg: unknown): arg is T =>
    typeof arg === 'object' && arg !== null;
